export default "__VITE_ASSET__ChrQNGSc__"